import { Component, EventEmitter, Output } from '@angular/core';
import { CourseTitleComponent } from "../../../ui/journey/course-title/course-title.component";
import { JourneySectionSelectorComponent } from "../../../ui/journey/journey-section-selector/journey-section-selector.component";
import { Section } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-student-section-selector',
	imports: [CourseTitleComponent, JourneySectionSelectorComponent],
	templateUrl: './student-section-selector.html',
	styleUrl: './student-section-selector.scss',
})
export class StudentSectionSelector {
	@Output('onSectionSelected') onSectionSelected: EventEmitter<Section> = new EventEmitter<Section>();
	@Output('onSectionsLoaded') onSectionsLoaded: EventEmitter<Section[]> = new EventEmitter<Section[]>();
}
